import script from "./CPA_Historico.vue?vue&type=script&setup=true&lang=js"
export * from "./CPA_Historico.vue?vue&type=script&setup=true&lang=js"

import "./CPA_Historico.vue?vue&type=style&index=0&id=3d2f0cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d2f0cde"]])

export default __exports__